/**
 * Utility to know if something is a plain object.
 */
export function isObject(obj) {
    return obj && typeof obj === 'object' && obj.constructor === Object;
}
